export const myOutlookLabel = "tanv0c";
export const outlookTodayLabel = "Garttb";
export const myProfileLabel = "PvJX2";
export const automationsLabel = "IbO4eb";
export const myMirrorLabel = "xR2Jcb";
export const hideMyOutlookLabel = "$aYzZd";
export const getStartedLabel = "RDiTIb";
export const analyzingDataLabel = "Dw4_kc";
export default {myOutlookLabel,outlookTodayLabel,myProfileLabel,automationsLabel,myMirrorLabel,hideMyOutlookLabel,getStartedLabel,analyzingDataLabel};